import './SolutionSection.css'
import React from 'react';
//import JoinPriorityWaitlistBtn from '../ViralLoops/JoinPriorityWaitlistBtn';
//import BetaWaitlist from "../Beta-Waitlist/BetaWaitlist";
function SolutionSection(props) {

    const onInitialSubmit = () => {
        props.setShowJoinWaitList(true);
    }
 
    return (
        <>
            <section id="eleven" className="perfect-solution">
                <div className="container">
                    <div className="row align-items-center reverse-columns" id='fleet'>
                        <div className="col-xl-5 col-lg-5 col-md-5 px-0 fleet-description">
                            <h6 className="">THE PERFECT SOLUTION </h6>
                            <h3>Fleet Sizes</h3>
                            <p className="">
                                Whether you're just getting started or have years of experience...we help
                                fleets ranging from one to hundreds of vehicles, across multiple branches.
                            </p>
                            <div className="solution-img-sec">
                                <img src="/img/obi-pixel.png" alt="Orb" className="img-fluid"/>
                            </div>
                            <ul className="fleet">
                                <li><img src="/img/check-icon.svg" alt="Check Icon" />1 - 5 Vehicles</li>
                                <li><img src="/img/check-icon.svg" alt="Check Icon" />6 - 25 Vehicles</li>
                                <li><img src="/img/check-icon.svg" alt="Check Icon" />26 - 100 Vehicles</li>
                                <li><img src="/img/check-icon.svg" alt="Check Icon" />100+ Vehicles</li>
                            </ul>
                        </div>

                        <div className="col-xl-7 col-lg-7 col-md-7 pb-lg-0 perfect-section-glry">
                            <div className="row">
                                <div className="col-xl-4 col-lg-4 col-md-4 pb-lg-0 perfection-inner-image1">
                                    <img src="/img/obi-pixel.png" alt="Orb" className="img-fluid"/>
                                </div>
                                <div className="col-xl-4 col-lg-4 col-md-4 pb-lg-0 perfection-inner-image">
                                    <img src="/img/connor.png" alt="Connor" className="img-fluid"/>
                                    <img src="/img/benjamin.png" alt="Benjamin" className="img-fluid"/>
                                </div>
                                <div className="col-xl-4 col-lg-4 col-md-4 pb-lg-0 perfection-inner-image1">
                                    <img src="/img/grant-richie.png" alt="Richie" className="img-fluid"/>
                                </div>
							</div>
                        </div>
                    </div>

                    <div className="row align-items-center partners"  id='partners'>
                        <div className="col-xl-6 col-lg-6 col-md-6 px-0">
                            <div className="row">
                                <div className="col-md-6 partner-img perfection-inner-image2">
                                    <img src="/img/Base-carousel-milti-image.png" className="w-100" alt="base" />
                                </div>
                                <div className="col-md-6 partner-img perfection-inner-image2">
                                    <img src="/img/enhanced-image.png" className="w-100" alt="base" />
                                </div>
                                <div className="col-md-6 lets-partner perfection-inner-image2">
                                    <img src="/img/Adobe-stock.png" className="w-100" alt="base" />
                                </div>
                                <div className="col-md-6 lets-partner perfection-inner-image2">
                                    <img src="/img/adobestock.png" className="w-100" alt="base" />
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-6 col-lg-6 col-md-6 solution-inner-sec">
                            <div className="rightcard ">
                                <h6 className="">SOMETHING FOR EVERYONE </h6>
                                <h3>Empowering Industries</h3>
                                <p className="">
                                    We're excited to partner with entrepreneurs who are passionate about
                                    enhancing the customer experience and committed to generating revenue, efficiently.
                                </p>
                                <div className="partner-img-sec">
                                    <img src="/img/Base-carousel-milti-image.png" className="w-100" alt="base Carousel" />
                                </div>
                                <ul className="fleet">
                                    <li><img src="/img/check-icon.svg" alt="Check Icon" /> Car Rental Agencies</li>
                                    <li><img src="/img/check-icon.svg" alt="Check Icon" /> Service & Repair / Auto body</li>
                                    <li><img src="/img/check-icon.svg" alt="Check Icon" /> Marketplace Hosts & Co-Hosts</li>
                                    <li><img src="/img/check-icon.svg" alt="Check Icon" /> Pre-owned and New Auto Dealerships</li>
                                    <li><img src="/img/check-icon.svg" alt="Check Icon" /> Hospitality and Parking Management Industries</li>
                                </ul>
                                <div className="col-md-12 px-1 mt-3">
                                    {/* <button type="button" id="join_wait" className="btn btn-dark waitlist_popup1" onClick={() =>{
                                     navigate('/?signup=waitlist')
                                    }}>Join Waitlist</button> */}
                                    <button id="join_wait" className='btn btn-dark waitlist_popup1' onClick={onInitialSubmit}>Join Waitlist</button>
                                    {/* <BetaWaitlist btn={true} btnId="join_wait" buttonClass="btn btn-dark waitlist_popup1" buttonText="Join the Waitlist" /> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default SolutionSection